"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxToggleAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormikAdapter = require("./FormikAdapter");

var _CheckboxToggle = require("../microFields/CheckboxToggle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * CheckboxToggle input type=checkbox
 * therefore this component assumes field.value is boolean
 * This field should always have initialValues set in the form
 */
var CheckboxToggleAdapter = function CheckboxToggleAdapter(_ref) {
  var form = _ref.form,
      field = _ref.field,
      atts = _ref.atts,
      label = _ref.label,
      cashbotName = _ref.cashbotName,
      styleType = _ref.styleType,
      openLinksInNewTab = _ref.openLinksInNewTab,
      isRequiredField = _ref.isRequiredField;
  return _react.default.createElement(_FormikAdapter.FormikAdapter, {
    form: form,
    field: field,
    options: {
      atts: atts
    },
    render: function render(props) {
      var _props$atts = props.atts,
          onChange = _props$atts.onChange,
          onFocus = _props$atts.onFocus,
          onBlur = _props$atts.onBlur;

      var handleChange = function handleChange(value) {
        // Format the boolean value into an object that the adapter and Formik are expecting
        onChange({
          target: {
            type: 'checkbox',
            name: field.name,
            checked: value
          }
        });
      };

      return _react.default.createElement(_CheckboxToggle.CheckboxToggle, _extends({}, props, {
        name: field.name,
        value: field.value,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: onBlur,
        label: label,
        cashbotName: cashbotName,
        styleType: styleType,
        openLinksInNewTab: openLinksInNewTab,
        isRequiredField: isRequiredField
      }));
    }
  });
};

exports.CheckboxToggleAdapter = CheckboxToggleAdapter;
CheckboxToggleAdapter.defaultProps = {
  atts: {},
  styleType: 'toggle',
  openLinksInNewTab: false,
  isRequiredField: false
};
CheckboxToggleAdapter.propTypes = {
  form: _propTypes.default.object.isRequired,
  field: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    // When clicking directly on the checkbox, the value is a boolean, but when
    // clicking on the <label> or using the spacebar, it can be an event
    value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]).isRequired,
    onChange: _propTypes.default.func.isRequired
  }).isRequired,
  atts: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  styleType: _propTypes.default.oneOf(['toggle', 'checkbox']),
  openLinksInNewTab: _propTypes.default.bool,
  isRequiredField: _propTypes.default.bool
};